// extracted by mini-css-extract-plugin
module.exports = {"container":"CancelRemoteLoadingModal_container__12bP_"};